import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConversationProvider } from './contexts/ConversationContext';
import { DatabaseConnectionProvider } from './contexts/DatabaseConnectionContext';
import { AppStateProvider } from './contexts/AppStateContext';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import ConversationInterface from './components/Conversation';
import DatabaseConnections from './components/DatabaseConnections/DatabaseConnections';
import GoldenSQLs from './components/GoldenSQLs/GoldenSQLs';
import Instructions from './components/Instructions/Instructions';
import Help from './components/Help/Help';
import Profile from './components/Profile/Profile';
import { PricingPage } from './components/Pricing';
import DashboardHome from './components/BI/DashboardHome';
import DashboardView from './components/Analytics/DashboardView';
import { isFeatureEnabled } from './config/features';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <AppStateProvider>
              <Toaster
                position="top-right"
                richColors
              />
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />

                {/* Protected routes with Layout */}
                <Route path="/" element={
                  <ProtectedRoute>
                    <DatabaseConnectionProvider>
                      <ConversationProvider>
                        <Layout />
                      </ConversationProvider>
                    </DatabaseConnectionProvider>
                  </ProtectedRoute>
                }>
                  <Route index element={<Home />} />
                  <Route path="query-generator" element={<ConversationInterface />} />
                  <Route path="analytics" element={<DashboardHome />} />
                  <Route path="analytics/dashboard/:dashboardId" element={<DashboardView />} />
                  <Route path="connections" element={<DatabaseConnections />} />
                  {isFeatureEnabled('GOLDEN_SQL') && (
                    <Route path="golden-sqls" element={<GoldenSQLs />} />
                  )}
                  <Route path="instructions" element={<Instructions />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="help" element={<Help />} />
                  <Route path="profile" element={<Profile />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppStateProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
